(() => {
  'use strict';
  const config = document.getElementById('theme-accessibility-labels');
  if (!config) return;
  const labels = config.dataset;
  const selector = '.ecom-shopify__list-collections, .ecom-swiper-button, div[class*="junip-product-"][aria-label], video.media-video, .popmechanic-input, #storeify-sl-btn-trigger-popup, .template-page .ecom-html a, .template-page .rte a';

  function repair(element) {
    if (element.matches('.ecom-shopify__list-collections') && element.getAttribute('role') === 'list') {
      element.removeAttribute('role');
    }
    if (element.matches('.ecom-swiper-button') && !element.hasAttribute('aria-label') && !element.hasAttribute('aria-labelledby')) {
      const label = element.classList.contains('ecom-swiper-button-prev') ? labels.previous : element.classList.contains('ecom-swiper-button-next') ? labels.next : '';
      if (label) element.setAttribute('aria-label', label);
    }
    if (element.matches('div[class*="junip-product-"][aria-label]') && !element.hasAttribute('role')) {
      element.setAttribute('role', 'group');
    }
    if (element.matches('video.media-video')) {
      const group = element.closest('.product-media');
      if (group) {
        group.setAttribute('role', 'group');
        group.setAttribute('aria-label', labels.video);
        element.removeAttribute('aria-label');
        element.removeAttribute('aria-labelledby');
      }
    }
    if (element.matches('.popmechanic-input') && !element.hasAttribute('aria-label') && !element.hasAttribute('aria-labelledby') && !element.labels?.length && element.type === 'email') {
      element.setAttribute('aria-label', labels.email);
    }
    if (element.id === 'storeify-sl-btn-trigger-popup' && !element.hasAttribute('aria-label')) {
      element.setAttribute('aria-label', labels.storeLocator);
    }
    if (element.matches('.template-page .ecom-html a, .template-page .rte a')) {
      const color = getComputedStyle(element).color;
      if (color === 'rgb(236, 0, 140)') element.setAttribute('data-a11y-pink-link', '');
    }
  }

  function scan(root) {
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;
    if (root.matches?.(selector)) repair(root);
    root.querySelectorAll(selector).forEach(repair);
  }

  function initializeTabs(root) {
    root.querySelectorAll('.tabs[role="tablist"]').forEach(list => {
      if (list.dataset.a11yInitialized) return;
      list.dataset.a11yInitialized = 'true';
      const tabs = Array.from(list.querySelectorAll('[role="tab"]'));
      const panels = tabs.map(tab => document.getElementById(tab.getAttribute('aria-controls')));
      const sync = selected => tabs.forEach((tab, index) => {
        const active = tab === selected;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (panels[index]) {
          panels[index].hidden = !active;
          panels[index].classList.toggle('tab-content--active', active);
        }
        tab.classList.toggle('tab--active', active);
      });
      tabs.forEach(tab => {
        tab.addEventListener('click', event => {
          event.preventDefault();
          sync(tab);
        });
        tab.addEventListener('keydown', event => {
          const index = tabs.indexOf(tab);
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) {
            event.preventDefault();
            tabs[next].focus();
            tabs[next].click();
          } else if (event.key === ' ') {
            event.preventDefault();
            tab.click();
          }
        });
      });
      sync(tabs.find(tab => tab.classList.contains('tab--active')) || tabs[0]);
    });
  }

  scan(document);
  initializeTabs(document);
  const observer = new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === 'childList') record.addedNodes.forEach(scan);
      else if (record.target.matches(selector)) repair(record.target);
    });
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label', 'aria-labelledby', 'role'] });
  window.addEventListener('load', () => scan(document), { once: true });
  document.addEventListener('shopify:section:load', event => {
    scan(event.target);
    initializeTabs(event.target);
  });
})();
